export default "__VITE_ASSET__0bc1754a__"